// Keep this definition in sync with schema/report-generation/report-generation-config.ts.
export const STANDARD_REPORT_EXECUTION_ORDER = [
  "ASSET_OWNERSHIP_AND_BENEFICIARIES",
  "CORPORATE",
  "ESTATE_GOALS_AND_RELATIONSHIPS",
  "HEALTH",
  "INSURANCE",
  "TAXES",
  "TRUST",
  "PROBATE",
] as const

export const REPORT_DEPENDENCY_GRAPH: Record<
  (typeof STANDARD_REPORT_EXECUTION_ORDER)[number],
  readonly (typeof STANDARD_REPORT_EXECUTION_ORDER)[number][]
> = {
  ASSET_OWNERSHIP_AND_BENEFICIARIES: [],
  CORPORATE: ["ASSET_OWNERSHIP_AND_BENEFICIARIES"],
  ESTATE_GOALS_AND_RELATIONSHIPS: [],
  HEALTH: [],
  INSURANCE: ["HEALTH"],
  TAXES: ["ASSET_OWNERSHIP_AND_BENEFICIARIES", "CORPORATE"],
  TRUST: ["ASSET_OWNERSHIP_AND_BENEFICIARIES", "ESTATE_GOALS_AND_RELATIONSHIPS"],
  PROBATE: ["ASSET_OWNERSHIP_AND_BENEFICIARIES", "TRUST", "TAXES"],
} as const
